// @flow
import { SERVER_ADDRESS, fetchGet } from '../util/actionsUtil';

export const FETCH_PATIENT_DATA_LOADING = 'FETCH_PATIENT_DATA_LOADING';
export const FETCH_PATIENT_DATA_SUCCESS = 'FETCH_PATIENT_DATA_SUCCESS';
export const FETCH_PATIENT_DATA_ERROR = 'FETCH_PATIENT_DATA_ERROR';

// dispatch LOADING action only on initial patient load (PatientTemplate.jsx)
export function fetchPatientDataInitial(patientId: string) {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/patient/id/${patientId}`,
      (data) => {
        dispatch({
          type: FETCH_PATIENT_DATA_SUCCESS,
          data: {
            ...data,
            activePatientId: patientId,
          },
        });
      },
      (error) => {
        dispatch({
          type: FETCH_PATIENT_DATA_ERROR,
          error: error.message,
        });
      });

    dispatch({
      type: FETCH_PATIENT_DATA_LOADING,
    });
  });
}

// Called every time an update is made to patient,
// doesn't dispatch loading action to prevent screen flicker
// Can make loading UI changes based on more specific update action,
// only re-render relevant sections
export function fetchPatientData(patientId: string) {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/patient/id/${patientId}`,
      (data) => {
        dispatch({
          type: FETCH_PATIENT_DATA_SUCCESS,
          data: {
            ...data,
            activePatientId: patientId,
          },
        });
      },
      (error) => {
        dispatch({
          type: FETCH_PATIENT_DATA_ERROR,
          error: error.message,
        });
      });
  });
}

export const ACTIVATE_PRINT_PATIENT = 'ACTIVATE_PRINT_PATIENT';
export const DEACTIVATE_PRINT_PATIENT = 'DEACTIVATE_PRINT_PATIENT';



// WEBPACK FOOTER //
// ./client/src/actions/patientActions.js